import HomeComponent from "components/homeComponent/HomeComponent";
import tatImg from "assets/images/tatImg.svg";
import styles from "./homepage.module.css";
import Shops from "components/shops/Shops";
import Container from "components/LogIn/Container";

function HomePage({ setItemss, itemss, updater, setUpdater }) {
  function changeUserInformation(newInfo) {
    // return setUserInformation(newInfo);
  }
  return (
    <>
      <HomeComponent
        setItemss={setItemss}
        updater={updater}
        setUpdater={setUpdater}
      />
      <Shops itemss={itemss} setItemss={setItemss} updater={updater} />
      <div className={` row mx-0 my-5 ${styles.bgWhat}`}>
        <div className="col-md-6 col-sm-12">
          <div className={styles.padin}>
            <div className="px-3">
              <h3 className="text-primary">تات کلاب چیست؟</h3>
              <div className={styles.divider}></div>
            </div>
            <p className="text-primary text-dark p-3">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
              استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
              نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
              کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
              جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای
              طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان
              فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری
              موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد
              نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل
              دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
            </p>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 text-center">
          <img src={tatImg} className={styles.whatTat} />
          <button className={` text-white ${styles.btnWhat}`}>
            <p
              className="pt-2 px-2"
              data-bs-toggle="modal"
              data-bs-target="#ModalNumber"
            >
              {" "}
              همین حالا به تات کلاب بپیوندید
            </p>
          </button>
          <Container changeUserInformation={changeUserInformation} />
        </div>
      </div>
    </>
  );
}

export default HomePage;
